import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { BasicInfoService } from "../../../services/basicinfo/basicinfo.service";

export class BancoPageService {

    mapAccounts(_accounts = [], { setNumAccountsArray, setNumAccountsArrayHide, setNumAccountsArrayCompleted, setFeatures, setAccountBooleanShowIcon }) {
        let accountNumberArrayCompleted = [];
        let accountNumberArrayHide = [];

        let mapAccount = _accounts.map((account, id) => {
            accountNumberArrayCompleted.push(account?.accountNumber);

            let details = [];
            let title = "";
            let check;
            if (account?.parent === true) {
                title = 'Principal';
                check = true;
            } else {
                title = 'Secundaria';
                check = false;
            }
            details.push({ name: "Banco: ", value: account?.bankAccount });
            details.push({ name: "Tipo de cuenta: ", value: account?.typeBankAccount });
            details.push({
                name: "Número de cuenta: ",
                value: account?.accountNumber.replace(account?.accountNumber.substr(0, 6), '********'),
                iconShow: <EyeIcon key={id} width={15} height={15} />,
                iconHide: <EyeSlashIcon key={id} width={15} height={15} />,
                index: id
            });
            accountNumberArrayHide.push(account?.accountNumber.replace(account?.accountNumber.substr(0, 6), '********'));

            return {
                title,
                id: account?.id,
                check,
                details,
                editBut: "Modificar",
                deleteBut: check ? "" : "Eliminar",
            };
        });

        setNumAccountsArray(accountNumberArrayHide);
        setNumAccountsArrayHide(accountNumberArrayHide);
        setNumAccountsArrayCompleted(accountNumberArrayCompleted)
        setFeatures(mapAccount);
        setAccountBooleanShowIcon(Array(mapAccount.length).fill(false));
        return;
    }


    async loadAccounts() {
        try {
            const data = await BasicInfoService.getBankAccountsWithLabel(localStorage.getItem("doc"));
            return data.message.info ?? [];
        } catch (error) {
            console.log(error);
        }
    };

    async loadBasicInfo() {
        try {
            const data = await BasicInfoService.getBasicInfo(localStorage.getItem("doc"));
            return data.message.info ?? {};
        } catch (error) {
            console.log(error);
        }
    };

    async determineAddMainAccount(doc, updateAddMainAccount) {

        try {
            let rsp = await BasicInfoService.hasCreditActive(doc);
            let {message} = rsp;
            updateAddMainAccount(!message);
            return;
        } catch (error) {
            console.log(error);
            return error?.message;
        }
    }

}